module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "author"
  }, [_vm._v("The daughter of the Reverend G. A. and Olga Adassa Morgan, Yvonne was born in St. Thomas, Jamaica. As a child she attended the Aeolus Valley All Age School and later Donald Quarrie Secondary School. She continued her education and also did Home Health which is her current occupation. She travelled to Panama, the Cayman Islands, Haiti, Curacao, and the United States looking for a better life. She enjoys babysitting, reading, writing, cooking, and going for nature walks.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035808434_Txt2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035808434_Txt3.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "c-heading ParaOverride-1"
  }, [_vm._v("Copyright © Yvonne Morgan-McKenzie 2024")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal ParaOverride-1"
  }, [_vm._v("The right of "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Yvonne Morgan-McKenzie")]), _vm._v(" to be identified as author of this work has been asserted by the author in accordance with sections 77 and 78 of the Copyright, Designs and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal ParaOverride-1"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal ParaOverride-1"
  }, [_vm._v("Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal ParaOverride-1"
  }, [_vm._v("A CIP catalogue record for this title is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal"
  }, [_vm._v("ISBN 9781035808434 (Paperback)")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal"
  }, [_vm._v("ISBN 9781035808441 (Hardback)")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal ParaOverride-1"
  }, [_vm._v("ISBN 9781035808458 (ePub e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal ParaOverride-1"
  }, [_vm._v("www.austinmacauley.com")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal"
  }, [_vm._v("First Published 2024")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal"
  }, [_vm._v("Austin Macauley Publishers Ltd®")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal"
  }, [_vm._v("1 Canada Square ")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal"
  }, [_vm._v("Canary Wharf ")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal"
  }, [_vm._v("London")]), _vm._v(" "), _c('p', {
    staticClass: "c-normal"
  }, [_vm._v("E14 5AA")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "ded-next ParaOverride-2"
  }, [_vm._v("Dedicated to the Morgan family.")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("To Brenda, my backbone, who crossed every ‘T’ and dotted every ‘I’. I will be forever grateful.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "book-text-next"
  }, [_vm._v("Little T had a bad cold and cough. Poor Little T also had a very high fever. Everyone became worried and wondered if Little T had come in contact with anyone at school who had Covid-19.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035808434_Txt7.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('p', {
    staticClass: "book-text-next"
  }, [_vm._v("Nana, Little T’s mother, came to get Little T ready for his doctor’s visit. He was so sick he couldn’t sing today, so Nana tried to make him feel better. She made him some delicious cornmeal porridge, of which he managed to eat only two spoons. He just couldn’t eat anymore.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035808434_Txt9.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('p', {
    staticClass: "book-text-next ParaOverride-1"
  }, [_vm._v("Nana tried to put it in his mouth but he was just too weak to eat the porridge. Nana was very worried.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("She began to sing:")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("“Nana baby has a cold on his chest, ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text ParaOverride-1"
  }, [_vm._v("Nana baby has a cold on his chest,”")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("And she began to rub him with some camphor oil. Nana finished dressing him. ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("She started thinking, I must call our village nurse to look at Little T before I take him out in public. ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("Nurse Logan arrived without delay. After examining him, she told Nana that Little T had a lot of symptoms of Covid-19.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer015"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035808434_Txt11.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer016"
    }
  }, [_c('p', {
    staticClass: "book-text-next"
  }, [_vm._v("She called the doctor in the town and asked what she should do. Nurse Logan told Dr. Blake that Little T had a fever, a pain in his belly, cough, sore throat, vomiting, diarrhea, and dizziness and he was very, very sick.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("Dr. Blake told the family to keep Little T in his room, with his mask on at all times. And that he should drink lots of warm tea, and Nana should have him tested for Covid-19.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("Sadly, Little T was tested positive. Hearing that, Nurse Logan ran to the health center to get a vaccine for Little T. The nurse told Nana to keep him in his room alone for ‘five’ days.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("Nana was worried. She kept her mask on. Everyone in the house got their vaccines and wore their masks to avoid getting Covid-19.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer018"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035808434_Txt13.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer019"
    }
  }, [_c('p', {
    staticClass: "book-text-next"
  }, [_vm._v("Nana washed all of Little T’s clothing separately.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer021"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035808434_Txt15.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer022"
    }
  }, [_c('p', {
    staticClass: "book-text-next"
  }, [_vm._v("She used gloves and was careful not to expose herself to getting this disease. She kept him out of the public so others would not get Covid from him. Nana complied with all the guidelines and followed Nurse Logan’s instruction on caring for Little T’s illness.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text ParaOverride-1"
  }, [_vm._v("After five days he was getting better. He started eating the food he liked. Little T was able to go by the river with his friends. He did not swim and they stayed apart from each other. Little T watched his friends play ‘lick or flip’ game on the water.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("While he sat on a tree stump, he sang:")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("“Never give up, never give up, ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("when you’re sick, never give up.”")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer024"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035808434_Txt17.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer025"
    }
  }, [_c('p', {
    staticClass: "book-text-next"
  }, [_vm._v("Nana took good care of Little T all those days. After a week’s time, Nurse Logan came again and had him tested for Covid. Little T was clear. No more sickness. When they heard the good news, his friends came and brought him sugar cane, plums, mangoes and June plums.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer027"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035808434_Txt19.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer028"
    }
  }, [_c('p', {
    staticClass: "book-text-next"
  }, [_vm._v("Little T was happy to see them and received the gifts of fruits.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer030"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035808434_Txt21.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer031"
    }
  }, [_c('p', {
    staticClass: "book-text-next"
  }, [_vm._v("They asked how he was feeling. Little T replied that he was feeling good and was glad to have company after being sick for a week.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer033"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035808434_Txt23.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer034"
    }
  }, [_c('p', {
    staticClass: "book-text-next"
  }, [_vm._v("Seeing them around again, he started to sing: ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("“Don’t worry about a thing, ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("every little thing is going to be alright.”")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer036"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035808434_Txt25.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer037"
    }
  }, [_c('p', {
    staticClass: "end"
  }, [_vm._v("THE END")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3ac6ff4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled2.vue
// module id = 57
// module chunks = 0